import { Alert, Grid } from '@gogame/components';
import { useStatusCompactDetails } from 'scenes/TapjoyBidUpdate/hooks/useStatusCompactDetails';
import { useLoadErrorDetails } from 'scenes/TapjoyBidUpdate/data/useLoadErrorDetails';

export default ({ statusDetails }) => {
  const { data: errorDetails } = useLoadErrorDetails();
  const getStatusCompactDetails = useStatusCompactDetails();

  if (!errorDetails) {
    return null;
  }
  return (
    <Grid item>
      <Alert title={errorDetails.errorMessage} severity={'warning'}>
        {getStatusCompactDetails('Completed with errors', statusDetails)}
      </Alert>
    </Grid>
  );
};
